function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#SVGID_1_)",
  d: "M18.201,2.5L9.123,6.818H9.091v6.818l-6.818,4.545v13.636l6.818,4.545v6.818l9.116,4.306 l-0.013-5.013l-4.558-2.159v-4.59l1.708-1.708c0.181,0.046,0.369,0.074,0.565,0.074c1.255,0,2.273-1.018,2.273-2.273 s-1.018-2.273-2.273-2.273s-2.273,1.018-2.273,2.273c0,0.211,0.031,0.414,0.085,0.608l-0.9,0.9l-6.003-3.952v-8.731l5.964-3.96 l0.928,0.928c-0.047,0.182-0.075,0.372-0.075,0.569c0,1.255,1.018,2.273,2.273,2.273s2.273-1.018,2.273-2.273 s-1.018-2.273-2.273-2.273c-0.209,0-0.411,0.031-0.604,0.084l-1.669-1.669V9.697l4.576-2.145l5.343,2.534l1.948-4.107L18.201,2.5z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  fill: "none",
  width: 50,
  height: 50
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#00D700",
  d: "M40.909,13.409V6.818L31.837,2.5l-9.11,4.318v17.045h-2.579c-0.393-0.679-1.125-1.136-1.966-1.136 c-1.255,0-2.273,1.018-2.273,2.273s1.018,2.273,2.273,2.273c0.841,0,1.573-0.458,1.966-1.136h2.579v14.167l-4.571,2.184 l0.025,5.013l9.091-4.318V26.136h2.579c0.393,0.679,1.125,1.136,1.966,1.136c1.255,0,2.273-1.018,2.273-2.273 s-1.018-2.273-2.273-2.273c-0.841,0-1.573,0.458-1.966,1.136h-2.579V9.697l4.564-2.178l4.527,2.179v3.939v0.731l-1.634,1.634 c-0.203-0.059-0.416-0.093-0.638-0.093c-1.255,0-2.273,1.018-2.273,2.273s1.018,2.273,2.273,2.273c1.255,0,2.273-1.018,2.273-2.273 c0-0.184-0.024-0.363-0.066-0.535l1.082-1.082l5.802,3.852v8.731l-6.136,4.04l-0.766-0.766c0.053-0.193,0.084-0.394,0.084-0.604 c0-1.255-1.018-2.273-2.273-2.273c-1.255,0-2.273,1.018-2.273,2.273s1.018,2.273,2.273,2.273c0.197,0,0.387-0.028,0.569-0.075 l1.704,1.704v4.369l-4.558,2.159l-0.013,5.013l9.116-4.306v-6.818l6.818-4.545V17.955L40.909,13.409z"
});

var SvgAiLogo = function SvgAiLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.2581,
    y1: 16.475,
    x2: 27.8986,
    y2: 30.7012
  }, React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#00D700"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00530A"
    }
  })), _ref2, _ref3, _ref4));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAiLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ai_logo.a7cbb2b5.svg";
export { ForwardRef as ReactComponent };